import { FieldError } from 'components/Form';
import React from 'react';

export const FormErrorsContext = React.createContext<Record<string, FieldError>>({});
